module.exports = __webpack_public_path__ + "img/tpc-15.a30799d5.jpg";